import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('pt_user');
    const token = localStorage.getItem('pt_token');
    if (stored && token) {
      try {
        setUser(JSON.parse(stored));
      } catch {
      localStorage.removeItem('pt_user');
      localStorage.removeItem('pt_token');
    }
  }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('pt_token', token);
    localStorage.setItem('pt_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('pt_token');
    localStorage.removeItem('pt_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
